import { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    <header
      className="page-header"
      style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "1rem" }}
    >
      <div>
        <h2>{title}</h2>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      {actions ? <div style={{ flexShrink: 0, display: "flex", gap: "0.5rem" }}>{actions}</div> : null}
    </header>
  );
}
